import { DT } from '../../theme/designTokens';

interface Props {
  label: string;
  value: string | number;
  /** Render value in gold. Use for positive metrics (wins, win rate). */
  gold?: boolean;
}

/** Editorial stat — large clamp-scaled number above a small uppercase label. */
export function StatBlock({ label, value, gold = false }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span
        style={{
          fontSize:      'clamp(24px, 3.2vw, 36px)',
          fontWeight:    800,
          lineHeight:    1,
          fontFamily:    DT.font.heading,
          color:         gold ? DT.color.gold : DT.color.textPrimary,
          letterSpacing: '-0.5px',
        }}
      >
        {value}
      </span>
      <span
        style={{
          fontSize:      10,
          fontWeight:    700,
          letterSpacing: '1.2px',
          textTransform: 'uppercase',
          color:         DT.color.textMuted,
          fontFamily:    DT.font.sans,
        }}
      >
        {label}
      </span>
    </div>
  );
}
